import styles from './QuizPlayerBadge.module.css';

interface Props {
  name: string;
  color: string;
}

export function QuizPlayerBadge({ name, color }: Props) {
  return (
    <div className={styles.badge}>
      <span className={styles.dot} style={{ background: color }} />
      {name}'s round
    </div>
  );
}
